import { Injectable } from "@angular/core";
import { LoadingController, Loading } from "ionic-angular";

@Injectable()
export class LoadingService {
  loadingIsOpen: boolean = false;
  loading: Loading;
  loadingMsg = "正在加载";
  timeout;

  constructor(private loadingCtrl: LoadingController) {}

  /**
   * 统一调用此方法显示loading
   * @param content 显示的内容
   */
  showLoading(content: string = this.loadingMsg): void {
    if (this.timeout) clearTimeout(this.timeout);
    if (!this.loadingIsOpen) {
      this.loadingIsOpen = true;
      this.loading = this.loadingCtrl.create({
        content: content,
        duration: 120000,
      });
      this.loading.present();
    }
  }

  /**
   * 关闭loading
   */
  hideLoading(): void {
    this.timeout = setTimeout(() => {
      this.loadingIsOpen && this.loading && this.loading.dismiss();
      this.loadingIsOpen = false;
    }, 200);
  }

  /**
   * 变更加载显示文本
   * @param content 显示文本
   */
  changeLoadContent(content: any) {
    if (!this.loadingIsOpen) return false;
    this.loading.setContent(content);
  }

  /**
   * 返回loading对象 自行操作的loading
   * @param content 初次加载显示文本
   */
  continuesLoading(content): Loading {
    return this.loadingCtrl.create({
      content: content,
      duration: 1000000000,
      dismissOnPageChange: false,
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/common/loading/loading.service.ts